module.exports = __webpack_public_path__ + "static/media/icon_arrow_down.ba707fe5.svg";